import { BASE_DRIVER_COLUMNS } from '../TransportTableHeading/TransportTableHeading.tsx'
import LocalizedFileInput from 'components/Erp/LocalizedFileInput';
import { tr } from 'i18n';
import VehicleNumberInput from 'components/Forms/VehicleNumberInput/VehicleNumberInput.tsx';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { SectionHeading, EmptyState } from 'components/Erp/Presentation';
import { Plus, Save, X, ChevronLeft, ChevronRight, Truck } from 'lucide-react';
import React from 'react'
import ResponsiveTable from './ResponsiveTable'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { hasAccess } from 'utils/access'
import DriverActions from './DriverActions'
import BaseDriverSummary from './BaseDriverSummary'
import BaseDriverDetails from './BaseDriverDetails'
import list from './DriverBaseList.module.scss'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'
import styles from '../AdminPanelPage.module.scss'

const DriversList = ({ tb, drivers = [], driversFilter = '', setDriversFilter = () => {},openCreateModal, loadDriversByTopBasePage = () => {}, employees = [], editingDriverByTopBase = {}, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, driversPagination = {}, expandedDriverByTopBase = {}, toggleDriver = () => {}, printDriverPass = () => {}, downloadDriverPass = () => {}, topBases = [], chpps = [], privatePoints = [] }) => {
  useInterfaceLanguage();
  const user=useSelector(state=>state.user)
  // Ensure drivers is always an array
  const safeDrivers = Array.isArray(drivers) ? drivers : []

  return (
    <div style={{ marginTop: 12 }}>
      <SectionHeading icon={Truck} title={tr("Водители этой ТОП-базы")} as="h3" actions={<div className={styles.actionGroup}>
        {tr(hasAccess(user,'drivers_edit') && <NavLink className={`${styles.smallBtn} ${styles.addButton}`} to={`/driver-register-admin/?destination=top_base:${tb.id}`}><Plus size={14} aria-hidden="true"/>{tr(" Регистрация водителя")}</NavLink>)}
        <div>
          {tr(hasAccess(user,'drivers_edit') && <button className={`${styles.smallBtn} ${styles.addButton}`} onClick={() => openCreateModal('driver', { top_base: tb.id, top_base_name: tb.name })}><Plus size={14} aria-hidden="true"/>{tr(" Добавить водителя")}</button>)}
        </div></div>} />
      <div style={{ marginTop: 8 }}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder={tr("Поиск...")} value={driversFilter || ''} onChange={(e) => setDriversFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadDriversByTopBasePage(tb.id, 1, driversFilter || '') }} />

        </div>
        {(safeDrivers && safeDrivers.length) ? (
          <>
            <ResponsiveTable className={`${styles.table} ${list.table}`}>
              <thead>
                <tr>{BASE_DRIVER_COLUMNS.map(label => <th key={label}>{tr(label)}</th>)}</tr>
              </thead>
              <tbody>
                {safeDrivers.map(d => (
                  <React.Fragment key={d.id}>
                    <BaseDriverSummary driver={d} expanded={expandedDriverByTopBase[tb.id] === d.id}
                    editing={editingDriverByTopBase?.[tb.id] === d.id} detailId={`base-driver-top_base-${tb.id}-${d.id}`}
                    onToggle={() => toggleDriver(tb.id, d.id)}
                    onEdit={hasAccess(user, 'drivers_edit') ? () => startEdit('driver', { topBase: tb.id, drId: d.id }, { employee: d.employee, top_base: d.top_base || tb.id, vehicle_number: d.vehicle_number, vehicle_model: d.vehicle_model, phone: d.phone, is_active: d.is_active }) : undefined} />
                  {tr(expandedDriverByTopBase[tb.id] === d.id && (
                    <tr>
                      <td colSpan={6}>
                        <div id={`base-driver-top_base-${tb.id}-${d.id}`} className={list.expanded}>
                          <DriverActions driver={d} edit={false} onChanged={() => loadDriversByTopBasePage(tb.id, driversPagination.page || 1, driversFilter)} />
                          <BaseDriverDetails driver={d}
                            onPrint={() => printDriverPass(d, tr("ТОПЛИВНАЯ БАЗА"), topBases.find(x => String(x.id) === String(d.top_base))?.name || tb.name || '')}
                            onDownload={() => downloadDriverPass(d, tr("ТОПЛИВНАЯ БАЗА"), topBases.find(x => String(x.id) === String(d.top_base))?.name || tb.name || '')} />
                        </div>
                      </td>
                    </tr>
                  ))}
                  {tr(editingDriverByTopBase[tb.id] === d.id && (
                      <tr>
                        <td colSpan={6}>
                          <div style={{ padding: 8 }}>
                            <p>{tr("Водитель")}: {tr(d.employee_name || "Без водителя")}</p>
                            <p>{tr("База")}: {tr(d.top_base_name || "Без базы")}</p>
                            <label style={{ marginLeft: 8 }}>{tr("Номер машины")}</label>
                            <VehicleNumberInput value={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).vehicle_number || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], vehicle_number: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>{tr("Модель")}</label>
                            <input value={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).vehicle_model || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], vehicle_model: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>{tr("Телефон")}</label>
                            <input value={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], phone: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>{tr("Активен")}</label>
                            <input type="checkbox" disabled={!hasAccess(user,'drivers_active')} aria-label={tr("Активность водителя")} checked={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], is_active: e.target.checked, actor_pin: '' } }))} />
                            {hasAccess(user, 'drivers_active') && !!(editPayloads[`driver_${tb.id}_${d.id}`] || {}).is_active !== !!d.is_active && (
                              <ActorPinField value={(editPayloads[`driver_${tb.id}_${d.id}`] || {}).actor_pin || ''}
                                onChange={pin => setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], actor_pin: pin } }))} />
                            )}

                            {/* Загрузка новых документов */}
                            <div style={{ marginTop: 16, borderTop: "1px solid var(--theme-border, #e0e0e0)", paddingTop: 12 }}>
                              <label>{tr("Добавить документы:")}</label>
                              <LocalizedFileInput
                                type="file"
                                multiple
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                                onChange={(e) => {
                                  setEditPayloads(p => ({ ...p, [`driver_${tb.id}_${d.id}`]: { ...p[`driver_${tb.id}_${d.id}`], newDocuments: Array.from(e.target.files || []) } }))
                                }}
                                style={{ marginTop: 4 }}
                              />
                              {tr(((editPayloads[`driver_${tb.id}_${d.id}`] || {}).newDocuments || []).length > 0 && (
                                <div style={{ marginTop: 8, fontSize: '13px', color: "var(--theme-text-muted, #666)" }}>{tr("Выбрано: ")}{tr((editPayloads[`driver_${tb.id}_${d.id}`] || {}).newDocuments.length)}{tr(" файл(ов)")}</div>
                              ))}
                            </div>

                            <div className={styles.actionGroup} style={{ marginTop: 8 }}>
                              <button className={styles.btn_pin} disabled={!!(editPayloads[`driver_${tb.id}_${d.id}`] || {}).is_active !== !!d.is_active && !/^[0-9]{4}$/.test((editPayloads[`driver_${tb.id}_${d.id}`] || {}).actor_pin || '')} onClick={() => saveEdit('driver', { topBase: tb.id, drId: d.id })}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                              <button className={styles.btn_pin_close} onClick={() => cancelEdit('driver', { topBase: tb.id })}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </ResponsiveTable>
            {tr((driversPagination && driversPagination.count > 0) && (
              <div className={styles.pagination}>
                <button disabled={!driversPagination.previous} onClick={() => loadDriversByTopBasePage(tb.id, (driversPagination.page || 1) - 1, driversFilter)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
                <span>{tr("Стр. ")}{tr(driversPagination.page || 1)}{tr(" из ")}{Math.ceil(driversPagination.count / 25)}{tr(" — Всего: ")}{tr(driversPagination.count)}</span>
                <button disabled={!driversPagination.next} onClick={() => loadDriversByTopBasePage(tb.id, (driversPagination.page || 1) + 1, driversFilter)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
              </div>
            ))}
          </>
        ) : (
          <div><EmptyState icon={Truck} title={tr("Водители на этой базе не найдены")} compact /></div>
        )}
      </div>
    </div>
  )
}

export default DriversList
